// @owners { team: patient-health }
import { createSelector } from 'reselect';
import { Dose } from '~shared/features/med-reminders/Dose';
import getMedicationKey from '~shared/features/med-reminders/helpers/getMedicationKey';
import { type Medication } from '~shared/features/my-meds/types';
import { type MedicationTakenEvent, type ReduxStateShared } from '~shared/types';
import { type PendingMedicationTakenEvent } from '~shared/types/medReminders';

export const getTakenEvents = (state: ReduxStateShared) => state.medicationTakenEvents.takenEvents;
export const getPendingTakenEvents = (state: ReduxStateShared) => state.medicationTakenEvents.pendingTakenEvents;
export const getLastSyncTakenEventsAttemptedAt = (state: ReduxStateShared) =>
  state.medicationTakenEvents.lastSyncTakenEventsAttemptedAt;
export const getSyncTakenEventsAttemptCount = (state: ReduxStateShared) =>
  state.medicationTakenEvents.syncTakenEventsAttemptCount;
export const getLastSyncTakenEventsSucceededAt = (state: ReduxStateShared) =>
  state.medicationTakenEvents.lastSyncTakenEventsSucceededAt;
export const getLastRequestAttemptedAt = (state: ReduxStateShared) =>
  state.medicationTakenEvents.lastRequestAttemptedAt;
export const getRequestAttemptCount = (state: ReduxStateShared) => state.medicationTakenEvents.requestAttemptCount;
export const getLastRequestSucceededAt = (state: ReduxStateShared) =>
  state.medicationTakenEvents.lastRequestSucceededAt;

export const getMergedTakenEvents = createSelector(
  [getTakenEvents, getPendingTakenEvents],
  (takenEvents: MedicationTakenEvent[], pendingTakenEvents: PendingMedicationTakenEvent[]): MedicationTakenEvent[] => {
    const { deleted, created } = pendingTakenEvents.reduce(
      (events, event) => {
        const dose = Dose.fromTakenEvent(event);

        if (event.deleted_at) {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type... (Delete me to see the full error)
          events.deleted[dose.occurrenceID] = true;
        } else {
          // @ts-expect-error TS(2345): Argument of type 'PendingMedicationTakenEvent' is not assignable to parameter of type 'never'.
          events.created.push(event);
        }

        return events;
      },
      {
        deleted: {},
        created: [],
      },
    );

    const activeTakenEvents = takenEvents.filter((event) => {
      return !event.deleted_at;
    });

    return [...activeTakenEvents, ...created].filter((event) => {
      const dose = Dose.fromTakenEvent(event);
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type... (Delete me to see the full error)
      return !deleted[dose.occurrenceID];
    });
  },
);

const filterTakenEventsByMed = (
  takenEvents: (MedicationTakenEvent | PendingMedicationTakenEvent)[],
  medication: Medication,
) => {
  return takenEvents.filter((takenEvent) => {
    const eventKey = getMedicationKey(takenEvent, medication.userID);
    return eventKey === medication.key;
  });
};

const getMedication = (_: ReduxStateShared, { medication }: { medication: Medication | null | undefined }) =>
  medication;

export const getTakenEventsPerMed = createSelector(
  [getMergedTakenEvents, getMedication],
  (
    takenEvents: (MedicationTakenEvent | PendingMedicationTakenEvent)[],
    medication: Medication | null | undefined,
    // @ts-expect-error TS(2322): Type '(MedicationTakenEvent | PendingMedicationTakenEvent)[]' is not assignable to type 'MedicationT... (Delete me to see the full error)
  ): MedicationTakenEvent[] => filterTakenEventsByMed(takenEvents, medication),
);
